import React, { useEffect } from "react";
import { getpayer } from "../../services/payer";
import { getServicecode } from "../../services/servicecode";
import { getBillingProvider } from "../../services/billingprovider";
import { getBillingCard } from "../../services";
import ClaimToolbar from "./ClaimToolbar";

function CreateClaim() {
  useEffect(() => {
    const payload = { page: 1 };
    getpayer(payload);
    getServicecode();
    getBillingProvider(payload);
    // getBillingCard();
  }, []);

  return <ClaimToolbar />;
}

export default CreateClaim;
